export const LIMIT_PER_PAGE = 50;

export const PaginationType = ['first', 'middle', 'last'] as const;
export type PaginationType = typeof PaginationType[number];
